import React, { useState, useEffect } from "react";
import "../../../style/google_forms.css";
import { useFormSubmission } from "../../pages/payment/customPayment";
import { EmailInput, RadioButtonInput, PhoneNumberInput } from "../../components/FormInitiators";
import { Loader } from "lucide-react";
import LoadingPage from "../../Loader";

function newAppointmentHS() {

  const initialFormState = {
    uniqueFormId: "",
    officeName: "",
    employeeName: "",
    email: "",
    phoneNumber: "",
    designation: "",
    dateOfAppointment: "",
    educationOfficer: "",
    adeshNumber: "",
    payScale: "",
    dateOfEnd: "",
    remark: "",
  };
  const dummyFormData = {
    officeName: "संत गाडगे महाराज माध्यमिक विद्यालय, पुणे",
    employeeName: "अनिल पाटील",
    email: "anil.patil@gmail.com",
    phoneNumber: "9876543210",
    designation: "शिक्षक",
    dateOfAppointment: "2023-03-16",
    educationOfficer: "शिक्षणाधिकारी शिक्षक",
    adeshNumber: "45678",
    payScale: "S-1",
    dateOfEnd: "2024-03-14",
    remark: "इतर अनुषंगिक माहिती",
  }
  const [formData, setFormData] = useState(initialFormState);
  
  const { handleFormSubmission, isSubmitting, PaymentWindowComponent } = useFormSubmission();



  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };


  const formConfig = {
    apiEndpoint: `${process.env.REACT_APP_BACKEND_URL}/api/newAppointmentHS/submit-newAppointmentHS`,
    paymentDescription: "Payment for New Appointment HS",
    successRoute: "/hsNewAppointment/hsNewAppointment-result",
    formType: "New Appointment HS",
    name: formData.employeeName,
    email: formData.email,
    contact: formData.phoneNumber,
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleFormSubmission(formData, formConfig);
  };


  return (
  <div>
    <div className="google_forms">
 
      <form className="forms" onSubmit={handleSubmit}>
        <h2>New Appointment</h2>

        <div>
          <label>शाळेचे नाव:</label>
          <input type="text" name="officeName" value={formData.officeName} onChange={handleInputChange} />
        </div>

        <div>
          <label>कर्मचाऱ्याचे  नाव:</label>
          <input type="text" name="employeeName" value={formData.employeeName} onChange={handleInputChange} />
        </div>

        <div>
          <EmailInput name="email" value={formData.email} onChange={handleInputChange} />
        </div>

        <div>
          <PhoneNumberInput name="phoneNumber" value={formData.phoneNumber} onChange={handleInputChange} />
        </div>

        <div>
          <label>पद:</label>
          <input type="text" name="designation" value={formData.designation} onChange={handleInputChange} />
        </div>
    
        <div>
            <label>नियमित वेतन स्तरातील नियुक्ती दिनांक:</label>
            <input type="date" name="dateOfAppointment" value={formData.dateOfAppointment} onChange={handleInputChange} />
        </div>
 
        <div>
        <label>शिक्षणाधिकारी / उपसंचालक यांचे कार्यालयाचे नाव </label>
          <input type="text" name="educationOfficer" placeholder="उदा - शिक्षणाधिकारी (माध्यमिक) सातारा जिल्हा परिषद सातारा " value={formData.educationOfficer} onChange={handleInputChange} />
        </div>


        <div>
        <label>नियुक्ती आदेश क्रमांक व दिनांक :</label>
          <input type="text" name="adeshNumber" placeholder="उदा - शिक्षण/मध्य . १/ नि . वे . श्रे./ २०२५/ २४१५  दि. १६/०५/२०२५" value={formData.adeshNumber} onChange={handleInputChange} />
        </div>

        <div>
        <label>नेमणुकीच्या  वेळचा वेतन स्तर:</label>
          <select name="payScale" value={formData.payScale || ""} onChange={handleInputChange}>
            <option value="" disabled>
              Select Pay Level
            </option>
            {Array.from({ length: 31 }, (_, i) => (
              <option key={`S${i+1}`} value={`S-${i+1}`}>{`S-${i+1}`}</option>
            ))}
          </select>
        </div>

        <div>
            <label> वेतन निश्चिती अंतिम दिनांक:</label>
            <input type="date" name="dateOfEnd" value={formData.dateOfEnd} onChange={handleInputChange} />
        </div>

        <div>
        <label>इतर अनुषंगिक माहिती : (optional)</label>
          <input type="text" name="remark" value={formData.remark} onChange={handleInputChange} />
        </div>

        <button
               className="single-button submit-button gap-2 px-4 py-2 text-white rounded-lg flex items-center justify-center disabled:opacity-60 disabled:cursor-not-allowed relative"
               type="submit"
               disabled={isSubmitting}
             >
               {isSubmitting && <Loader className="animate-spin mr-2" />}
               {isSubmitting ? "Submitting..." : "Submit"}
             </button>
       
      </form>
 

    </div>
    {isSubmitting}

    {PaymentWindowComponent}

    </div>
  );
}

export default newAppointmentHS;
